module.exports = __webpack_public_path__ + "static/assets/27936801401d3ac0705de9a1ed89f2d6.svg";